"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Error = _interopRequireDefault(require("./../Messages/Error"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ThemePicker = function ThemePicker(_ref) {
  var themes = _ref.themes,
      activeTheme = _ref.activeTheme,
      name = _ref.name,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      opensUp = _ref.opensUp,
      className = _ref.className,
      error = _ref.error,
      otherProps = _ref.otherProps,
      children = _ref.children;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentTheme = _useState2[0],
      setCurrentTheme = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var inputRef = (0, _react.useRef)();
  var containerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var newTheme = {};
    Object.keys(themes).map(function (key) {
      if (key === activeTheme) {
        newTheme.name = key;
        newTheme.color = themes[key];
        setCurrentTheme(newTheme);
      }
    });
  }, [activeTheme]);

  var handleInputClickOutside = function handleInputClickOutside(e) {
    if (disabled || isOpen) return;

    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleInputClickOutside, true);
    return function () {
      document.removeEventListener('click', handleInputClickOutside, true);
    };
  }, []);
  (0, _react.useEffect)(function () {
    onChange(currentTheme);
  }, [currentTheme]);

  var handleOpenClose = function handleOpenClose() {
    if (disabled && !isOpen) return;
    setIsOpen(!isOpen);
  };

  var handleInputKey = function handleInputKey(e) {
    if (!disabled) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        setIsOpen(function (prevValue) {
          return !prevValue;
        });
      }
    }
  };

  var handleInputKeyOption = function handleInputKeyOption(e, key, theme) {
    if (!disabled) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        handleColorSelect(key, theme);
      }
    }
  };

  var handleColorSelect = function handleColorSelect(colorName, colorCode) {
    if (disabled) return;
    var newTheme = {};
    newTheme.name = colorName;
    newTheme.color = colorCode;
    setCurrentTheme(newTheme);
    inputRef.current.focus();
    setIsOpen(false);
  };

  return /*#__PURE__*/_react.default.createElement(StyledThemePicker, _extends({
    className: className,
    ref: containerRef
  }, otherProps), /*#__PURE__*/_react.default.createElement(Label, {
    htmlFor: name
  }, children), /*#__PURE__*/_react.default.createElement(StyledDropDown, null, /*#__PURE__*/_react.default.createElement(ThemePickerInput, {
    ref: inputRef,
    onKeyDown: handleInputKey,
    tabIndex: "0",
    error: error,
    opensUp: opensUp,
    onClick: handleOpenClose,
    isOpen: isOpen,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(ColorBlock, {
    color: currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.color
  }), /*#__PURE__*/_react.default.createElement(ColorName, {
    disabled: disabled
  }, currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.name), /*#__PURE__*/_react.default.createElement(DropdownIcon, null, /*#__PURE__*/_react.default.createElement(_Icons.IconChevronDown, {
    size: 30
  })), /*#__PURE__*/_react.default.createElement(StyledError, {
    error: error
  })), disabled ? null : /*#__PURE__*/_react.default.createElement(ThemePickerDropdown, {
    opensUp: opensUp,
    isOpen: isOpen
  }, Object.keys(themes).map(function (key) {
    return /*#__PURE__*/_react.default.createElement(DropdownItem, {
      key: key,
      tabIndex: "0",
      onKeyDown: function onKeyDown(e) {
        return handleInputKeyOption(e, key, themes[key]);
      },
      onClick: function onClick() {
        handleColorSelect(key, themes[key]);
      }
    }, /*#__PURE__*/_react.default.createElement(ColorDrop, {
      color: themes[key]
    }), /*#__PURE__*/_react.default.createElement(ColorName, null, key));
  }))));
};

var StyledError = (0, _styledComponents.default)(_Error.default).withConfig({
  displayName: "StyledError"
})(["position:absolute;top:100%;right:0;"]);

var StyledThemePicker = _styledComponents.default.div.withConfig({
  displayName: "StyledThemePicker"
})(["width:100%;height:9rem;max-width:100rem;position:relative;font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var StyledDropDown = _styledComponents.default.div.withConfig({
  displayName: "StyledDropDown"
})(["position:relative;"]);

var ThemePickerInput = _styledComponents.default.div.withConfig({
  displayName: "ThemePickerInput"
})(["width:100%;height:4.5rem;background:", ";border:1px solid ", ";border-radius:", ";display:flex;justify-content:space-between;align-items:center;padding:0.6rem;cursor:", ";transition:border-radius 0.2s ease;&:focus{outline:0;border:1px solid ", ";}"], function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? '#F0F1F3' : 'white';
}, function (_ref4) {
  var disabled = _ref4.disabled,
      error = _ref4.error;
  return disabled ? '#F0F1F3' : error ? 'red' : '#e4e4e4';
}, function (_ref5) {
  var isOpen = _ref5.isOpen,
      opensUp = _ref5.opensUp;
  return isOpen && opensUp ? '0 0 5px 5px' : isOpen ? '5px 5px 0 0' : '5px';
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref7) {
  var theme = _ref7.theme,
      disabled = _ref7.disabled;
  return !disabled ? theme.brand.primary : 'rgba(0,0,0,0)';
});

var ColorBlock = _styledComponents.default.div.withConfig({
  displayName: "ColorBlock"
})(["width:3.3rem;height:3.3rem;background-color:", ";margin-right:1.6rem;border-radius:0.5rem;flex:0 0 3.3rem;"], function (_ref8) {
  var color = _ref8.color;
  return color ? color : '#222';
});

var DropdownIcon = _styledComponents.default.div.withConfig({
  displayName: "DropdownIcon"
})(["opacity:0.5;svg path{fill:#c1c1c1;}"]);

var ThemePickerDropdown = _styledComponents.default.div.withConfig({
  displayName: "ThemePickerDropdown"
})(["visibility:", ";position:absolute;top:", ";bottom:", ";left:0;right:0;height:15rem;max-height:", ";overflow-y:scroll;border:1px solid #e4e4e4;z-index:9999;background-color:white;flex-flow:column;border-radius:", ";transition:all 0.2s ease;&::-webkit-scrollbar{-webkit-appearance:none;}&::-webkit-scrollbar:vertical{width:12px;}&::-webkit-scrollbar:horizontal{height:8px;}&::-webkit-scrollbar-thumb{border-radius:8px;border:2px solid white;background-color:#c7c7c7;}&::-webkit-scrollbar-track-piece{background:#f0f1f3;border-radius:5px;width:8px;border:2px solid white;}"], function (_ref9) {
  var isOpen = _ref9.isOpen;
  return isOpen ? 'visible' : 'hidden';
}, function (_ref10) {
  var opensUp = _ref10.opensUp;
  return opensUp ? 'auto' : '100%';
}, function (_ref11) {
  var opensUp = _ref11.opensUp;
  return opensUp ? '100%' : 'auto';
}, function (_ref12) {
  var isOpen = _ref12.isOpen;
  return isOpen ? '15rem' : '0';
}, function (_ref13) {
  var opensUp = _ref13.opensUp;
  return opensUp ? '5px 5px 0 0' : '0 0 5px 5px';
});

var DropdownItem = _styledComponents.default.div.withConfig({
  displayName: "DropdownItem"
})(["height:4.5rem;width:100%;flex:0 0 4.5rem;display:flex;justify-content:flex-start;align-items:center;padding:1.5rem;background-color:white;cursor:pointer;&:hover{outline:none;background-color:#f0f1f3;}&:focus{outline:none;border:1px solid ", ";}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.brand.primary;
});

var ColorDrop = _styledComponents.default.div.withConfig({
  displayName: "ColorDrop"
})(["width:1.5rem;height:1.5rem;background-color:", ";border-radius:99999px;margin-right:2.4rem;"], function (_ref15) {
  var color = _ref15.color;
  return color;
});

var ColorName = _styledComponents.default.div.withConfig({
  displayName: "ColorName"
})(["font-family:", ";font-size:1.6rem;line-height:120%;color:", ";flex:1 0 auto;text-transform:capitalize;"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.font;
}, function (_ref17) {
  var disabled = _ref17.disabled;
  return disabled ? '#8990A3' : '#222';
});

var Label = _styledComponents.default.label.withConfig({
  displayName: "Label"
})(["font-family:", ";font-size:1.4rem;line-height:120%;color:#8990a3;margin-bottom:0.8rem;display:block;"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.font;
});

ThemePicker.propTypes = {
  /** An object containing all possible themes and their hexcodes. */
  themes: _propTypes.object.isRequired,

  /** string with errormessage */
  error: _propTypes.string,

  /** name of input and label */
  name: _propTypes.string.isRequired,

  /** The key of the initial active theme. */
  activeTheme: _propTypes.string.isRequired,

  /** Label to be displayed above the input. */
  children: _propTypes.node,

  /** onChange handler when a theme is picked */
  onChange: _propTypes.func.isRequired,

  /** Disabled the operation and selection of colors. */
  disabled: _propTypes.bool,

  /** Opens the dropdown up instead of down */
  opensUp: _propTypes.bool,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = ThemePicker;
exports.default = _default;